import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import AdminNavbar from './AdminNavbar';
import Footer from './Footer';
import './ProtectedRoute.css';

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const isAuthenticated = token !== null;

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSecondaryOpen, setIsSecondaryOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleSecondarySidebar = (isOpen) => {
    setIsSecondaryOpen(isOpen);
  };

  if (!isAuthenticated) {
    return <Navigate to="/signin" />;
  }

  return (
    <div>
      <div>
        <AdminNavbar />
        {children}
      </div>
    </div>
  );
};

export default AdminRoute;
